import type { InativarPapelObraDialogProps } from "./types-inativar-papel-obra-dialog";
import { useInativarPapelObraDialog } from "./use-inativar-papel-obra-dialog";
import { InativarPapelObraDialogView } from "./view-inativar-papel-obra-dialog";

/** Modal "Inativar Papel" (HU 2037). */
export function InativarPapelObraDialog(props: InativarPapelObraDialogProps) {
  const vm = useInativarPapelObraDialog(props);

  return <InativarPapelObraDialogView {...vm} />;
}

export type * from "./types-inativar-papel-obra-dialog";
